import React, { Component } from "react";
import BsySlidePane from "../../BsySlidePane";
import BsyDashboardFlowCenter from "../BsyDashboardFlowCenter";

import { BsyUtils } from "../../../utils/Utils";
import emptyImg from "../../../images/img_wugongzuo.png";
import { BrowserRouter, withRouter } from "react-router-dom";

import "./index.css";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsyFormPane from "../../BsyFormPane";
import todoEmptyImg from "../../../images/dashboard/todo-empty-img.png";
import BsyBadge from "../../BsyBadge";
import BsySLoading from "../../BsySLoading";
import { dayjsUtils } from "../../../utils/dayjsUtils";

class BsyDashboardFlowPaneV2 extends Component {
  static defaultProps = {
    layout: "horizontal", //vertical  理论上应该默认 horizontal,
    todocount: 0,
    dockcount: 0,
    dockCorp: [],
    corp_count: {},
    default_corp: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      block: props.block,
      layout: props.layout,
      dockCorp: props.dockCorp,
      mode: props.mode,
      designMode: props.designMode,
      flowManagementType: props.flowManagementType || "card-cross",
      todocount: 0,
      dockcount: 0,
      urgecount: 0,
      aboutcount: 0,
      timeoutcount: 0,
      loadSuccess: false,
      countLoading: true,
      avatarMap: {},
      corp_count: {},
      default_corp: "",
      corpId: props.dockCorp.length > 0 ? props.dockCorp[0]._id : "",
      nameMap: {},
      dataList: [],
      flowActive: "internalFlow",
      cardTypeWidh: "",
    };
    this.renderFlowIndex = 0;
    this.noreferrer = React.createRef();
  }

  todo = (f) => {
    const { flowActive, corpId } = this.state;
    let that = this;
    this.setState({ loadSuccess: f }, () => {
      React.axios("/dashboard/flow_todo_count", {})
        .then((res) => {
          function next() {
            React.axios("/dashboard/flow_todo", {
              appId: "todo",
              hascount: true,
              mode: flowActive,
              corpId: corpId,
              limit: 20,
              skip: 0,
              sort: { updateTime: -1 },
              type: "todo",
              filter: {
                cond: [
                  {
                    field: "urgeTime",
                    type: "urgeTime",
                    hasEmpty: false,
                    method: "not_empty",
                    value: null,
                  },
                ],
                rel: "and",
              },
            })
              .then((res1) => {
                that.setState({
                  urgecount: res1.data.count,
                });
              })
              .catch((res) => {
                console.error(res);
              });
            let nowDate = dayjsUtils.timeToTZ(new Date());
            let nowDate1 = dayjsUtils.timeToTZ(new Date());
            React.axios("/dashboard/flow_todo", {
              appId: "todo",
              hascount: true,
              mode: flowActive,
              corpId: corpId,
              limit: 20,
              skip: 0,
              sort: { updateTime: -1 },
              type: "todo",
              filter: {
                cond: [
                  {
                    field: "flowExpireTime",
                    type: "datetime",
                    hasEmpty: false,
                    method: "range",
                    value: [
                      BsyUtils.getNowDateTime(nowDate),
                      BsyUtils.getNowDateTime(
                        new Date(
                          nowDate1.setTime(
                            nowDate1.getTime() + 24 * 60 * 60 * 1000
                          )
                        )
                      ),
                    ],
                  },
                ],
                rel: "and",
              },
            })
              .then((res2) => {
                that.setState({
                  aboutcount: res2.data.count,
                });
              })
              .catch((res) => {
                console.error(res);
              });
            React.axios("/dashboard/flow_todo", {
              appId: "todo",
              hascount: true,
              mode: flowActive,
              corpId: corpId,
              limit: 20,
              skip: 0,
              sort: { updateTime: -1 },
              type: "todo",
              filter: {
                cond: [
                  {
                    field: "flowExpireTime",
                    type: "datetime",
                    hasEmpty: false,
                    method: "lt",
                    value: [BsyUtils.getNowDateTime()],
                  },
                ],
                rel: "and",
              },
            })
              .then((res3) => {
                that.setState({
                  timeoutcount: res3.data.count,
                });
              })
              .catch((res) => {
                console.error(res);
              });
            React.axios("/dashboard/flow_urge_todo", {
              mode: flowActive,
              corpId: corpId,
            })
              .then((res5) => {
                if (res5.data.isUrge) {
                  let dataList = [];
                  res5.data.data.map((val, key) => {
                    if (key < 3) {
                      dataList.push(val);
                    }
                  });
                  that.setState({
                    avatarMap: res5.data.avatarMap,
                    nameMap: res5.data.nameMap,
                    loadSuccess: true,
                    dataList,
                  });
                } else {
                  let dataList = [];
                  res5.data.data.map((val, key) => {
                    if (key < 3) {
                      dataList.push(val);
                    }
                  });
                  that.setState({
                    avatarMap: res5.data.avatarMap,
                    nameMap: res5.data.nameMap,
                    loadSuccess: true,
                    dataList,
                  });
                }
              })
              .catch((res) => {
                console.error(res);
              });
          }

          this.setState(
            {
              todocount: res.data.count,
              loadSuccess: res.data.count === 0 ? true : false,
              countLoading: false,
              dockcount: res.data.dock_count,
              corp_count: res.data.corp_count,
              default_corp: res.data.default_corp,
              corpId: res.data.default_corp,
            },
            () => {
              if (res.data.count > 0) {
                next();
              }
            }
          );
        })
        .catch((res) => {
          console.error(res);
        });
    });
  };

  componentDidMount() {
    this.todo(false);
  }
  ///flow_todo_count

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      layout: nextProps.layout,
    });
  }

  getContext = (context) => {
    this.BsySlideContext = context;
  };

  clickFlowMenu = (id, filterType, isDock) => {
    // this.props.history.push('/flow/'+id)
    const {
      flowActive,
      corpId,
      dockcount,
      todocount,
      corp_count,
      default_corp,
    } = this.state;

    this.props.history.push("/team/" + id, {
      type: id,
      mode: flowActive,
      corpId: corpId,
      dockCorp: this.state.dockCorp,
      filterType: filterType,
      isDock: !!isDock,
      dockcount: dockcount,
      todocount: todocount,
      corp_count: corp_count,
      default_corp: default_corp,
    });

    // BsySlidePane({
    //   title: React.language("flow.center"),
    //   customCls: "bsy-dashboard-flow-center",
    //   getContext: this.getContext,
    //   onContentCreate: () => {
    //     return (
    //       <BrowserRouter>
    //         <BsyDashboardFlowCenter
    //           type={id}
    //           mode={flowActive}
    //           corpId={corpId}
    //           dockCorp={this.state.dockCorp}
    //           filterType={filterType}
    //           isDock={!!isDock}
    //           dockcount={dockcount}
    //           todocount={todocount}
    //           corp_count={corp_count}
    //           default_corp={default_corp}
    //         />
    //       </BrowserRouter>
    //     );
    //   },
    //   onClose: () => {
    //     this.todo(true);
    //   },
    // });
  };

  _editData = (b, c1) => {
    return () => {
      var c = this;

      let that = this;

      const { restore } = BsyUtils.globalIdManager(b.appId, b.entryId, b._id);
      // TODO 修复首页弹出的页面只能查看流程  不能审批流程
      b.flowType = c1;

      let layerRef = null;
      BsyMaskLayer({
        customCls: "fadein-right",
        onMaskClick: (event) => {
          // if (event.target.classList.contains("fadein-right")) {
          //   layerRef.close();
          // }
        },
        onContentCreate: (ref) => {
          layerRef = ref;

          return (
            <BsyFormPane
              {...b}
              mode={"edit"}
              onSuccess={(e) => {
                restore();
                that.todo(true);

                layerRef && layerRef.close();
                // that.setState({
                //     page: 0,
                //     // scrollDataLength: 0,
                // }, () => {
                //     that.renderFlowIndex++;
                //     that.scrollLoad();
                // })
              }}
              onClose={(e) => {
                restore();
                // that.todo(true);
                layerRef && layerRef.close();
              }}
            />
          );
        },
      });
      return;
    };
  };
  _close = () => {
    this.$mask.remove();
    this.$mask = null;
    this.form = null;
  };

  render() {
    const {
      layout,
      todocount,
      urgecount,
      aboutcount,
      timeoutcount,
      dataList,
      nameMap,
      avatarMap,
      loadSuccess,
      countLoading,
      dockcount,
      flowManagementType,
      designMode,
    } = this.state;
    return (
      <>
        {(!flowManagementType ||
          flowManagementType.indexOf("card") >= 0 ||
          designMode === "phone") && (
          <div
            className={
              "dashboard-flow-pane-v2 " +
              (dockcount > 0 ? "hasDock " : "") +
              layout +
              " " +
              flowManagementType
            }
          >
            <div className="dashboard-flow-left" ref={this.noreferrer}>
              {countLoading ? (
                <BsySLoading mode={"skeletonspin"} />
              ) : (
                <>
                  {todocount === 0 ? (
                    <>
                      <div className="todo-empty">
                        <img src={todoEmptyImg} alt="" />
                        <div className="todo-empty-msg">
                          {React.language("todo.empty.msg")}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="todo item">
                      <div
                        className="left"
                        onClick={(e) => {
                          this.clickFlowMenu("todo");
                        }}
                      >
                        <div className="logo">
                          <div className={"icon-bsy-todo-react"}></div>
                        </div>
                        <div className="left-content">
                          <div className="title">
                            {React.language("flow.visit.todo")}
                          </div>
                          <div className="num">
                            {todocount > 0 ? todocount : ""}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          "right " +
                          ((urgecount && loadSuccess) > 0 ? "urge" : "")
                        }
                      >
                        {!loadSuccess && (
                          <div className="todoLoading">
                            <div className="todoHeader loading"></div>
                            <div className="todoBody loading">
                              {
                                <div className="todoList">
                                  <div className="todoList-item"></div>
                                  <div className="todoList-item"></div>
                                  <div className="todoList-item"></div>
                                </div>
                              }
                            </div>
                          </div>
                        )}
                        {loadSuccess && (
                          <>
                            <div className="todoHeader">
                              {todocount > 0 && (
                                <>
                                  <div className="todoTitle">
                                    {urgecount > 0
                                      ? React.language("latest.to.do.urge")
                                      : React.language("latest.to.do")}
                                  </div>
                                  <div className="todoMenu">
                                    <div
                                      className="todoMenu-item"
                                      onClick={(e) => {
                                        this.clickFlowMenu("todo", "urge");
                                      }}
                                    >
                                      <span>{React.language("flow.Urge")}</span>
                                      <span className="num">{`(${urgecount})`}</span>
                                    </div>
                                    <div
                                      className="todoMenu-item"
                                      onClick={(e) => {
                                        this.clickFlowMenu(
                                          "todo",
                                          "flowExpireTime"
                                        );
                                      }}
                                    >
                                      <span>
                                        {React.language("about.to.time.out")}
                                      </span>
                                      <span className="num">{`(${aboutcount})`}</span>
                                    </div>
                                    <div
                                      className="todoMenu-item"
                                      onClick={(e) => {
                                        this.clickFlowMenu("todo", "timeout");
                                      }}
                                    >
                                      <span>{React.language("timeout")}</span>
                                      <span className="num">{`(${timeoutcount})`}</span>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="todoBody">
                              {dataList.length > 0 ? (
                                <div className="todoList">
                                  {dataList.map((res, index) => {
                                    let user = res.creator;
                                    let name = nameMap[user]
                                      ? BsyUtils._toDeptUser(nameMap[user])
                                      : React.language("widget.user.anonymous");
                                    let avatar = avatarMap[user];
                                    const bg = BsyUtils.formatUserThumb(name);
                                    return (
                                      <div
                                        className="todoList-item"
                                        onClick={this._editData(
                                          {...res,
                                            dataId: res._id,
                                          },
                                          "todo"
                                        )}
                                        key={"todo-" + index}
                                      >
                                        <div className="newsCont">
                                          {avatar &&
                                          avatar.indexOf("://") > -1 ? (
                                            <div className="todoImg">
                                              <img src={avatar} alt="" />
                                            </div>
                                          ) : (
                                            <div
                                              className={`todoUserPortrait table-user-portrait-name color-${bg.color}`}
                                            >
                                              <span>{bg.name}</span>
                                            </div>
                                          )}

                                          <div className="todoUserName">
                                            <span>{name}</span>
                                          </div>
                                          <div className="todoFrom">
                                            <span>
                                              {window.hasJarvisbim
                                                ? " "
                                                : React.language("todo.from")}
                                            </span>
                                            <span className="fromName">
                                              {res.entryName}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="timeCont">
                                          {BsyUtils.date2Str(
                                            dayjsUtils.timeToTZ(res.updateTime),
                                            "yyyy-MM-dd HH:mm:ss"
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                <div className="todoEmpty">
                                  <img src={emptyImg} alt="" />
                                  <div className="todoEmptyMsg">
                                    {React.language("todo.empty.msg")}
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                      {/* {dockcount > 0 && <div className='dockRight' onClick={e => { this.clickFlowMenu('todo', null, true) }} >
                            <div className='left-content'>
                                <div className='title'>{React.language('dock.flow.todo')}</div>
                                <div className='num'> {dockcount} </div>
                            </div>
                        </div>} */}
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="dashboard-flow-right">
              <div
                className={"flow-item"}
                onClick={(e) => {
                  this.clickFlowMenu("cc");
                }}
              >
                <div className="cc item">
                  <div className="left">
                    <div className="left-content">
                      <div className="title">
                        {React.language("flow.visit.cc")}
                      </div>
                      <div className="num"> </div>
                    </div>
                  </div>
                  <div className="right">
                    <div className="logo">
                      <i className={"icon-new-chaosongwode"}></i>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={"flow-item"}
                onClick={(e) => {
                  this.clickFlowMenu("transactors");
                }}
              >
                <div className="transactors item">
                  <div className="left">
                    <div className="left-content">
                      <div className="title">
                        {React.language("flow.my.transactors")}
                      </div>
                      <div className="num"> </div>
                    </div>
                  </div>
                  <div className="right">
                    <div className="logo">
                      <i className={"icon-new-wochulide"}></i>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={"flow-item"}
                onClick={(e) => {
                  this.clickFlowMenu("create");
                }}
              >
                <div className="create item">
                  <div className="left">
                    <div className="left-content">
                      <div className="title">
                        {React.language("flow.visit.create")}
                      </div>
                      <div className="num"> </div>
                    </div>
                  </div>

                  <div className="right">
                    <div className="logo">
                      <i className={"icon-new-wofaqide"}></i>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={"flow-item"}
                onClick={(e) => {
                  this.clickFlowMenu("launch");
                }}
              >
                <div className="launch item">
                  <div className="left">
                    <div className="left-content">
                      <div className="title">
                        {React.language("flow.create.n2")}
                      </div>
                      <div className="num"> </div>
                    </div>
                  </div>

                  <div className="right">
                    <div className="logo">
                      <i className={"icon-new-faqiliucheng"} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {flowManagementType === "combo" && designMode !== "phone" && (
          <div className="dashboard-flow-left t-combo-dashboard-flow-left">
            <ul>
              <li className="t-item t-todo" onClick={(e) => {
                    this.clickFlowMenu("todo");
                  }}>
                <i className="img-box icon-new-wodedaiban"></i>
                <div className="right-box">
                  <div className="title">
                    {React.language("flow.visit.todo")}
                  </div>
                  {/* <div className='num'> {todocount} </div> */}
                </div>
                {todocount > 0 && (
                  <BsyBadge className={"red"}>{todocount}</BsyBadge>
                )}
              </li>
              <li
                className="t-item t-cc"
                onClick={(e) => {
                  this.clickFlowMenu("cc");
                }}
              >
                <i className="img-box icon-new-chaosongwode"></i>
                <div className="right-box">
                  <div className="title">{React.language("flow.visit.cc")}</div>
                </div>
              </li>
              <li
                className="t-item t-transactors"
                onClick={(e) => {
                  this.clickFlowMenu("transactors");
                }}
              >
                <i className="img-box icon-new-wochulide"></i>
                <div className="right-box">
                  <div className="title">
                    {React.language("flow.my.transactors")}
                  </div>
                </div>
              </li>
              <li
                className="t-item t-create"
                onClick={(e) => {
                  this.clickFlowMenu("create");
                }}
              >
                <i className="img-box icon-new-wofaqide"></i>
                <div className="right-box">
                  <div className="title">
                    {React.language("flow.visit.create")}
                  </div>
                </div>
              </li>
              <li className="line"></li>
              <li
                className="t-item t-n2"
                onClick={(e) => {
                  this.clickFlowMenu("launch");
                }}
              >
                <i className="img-box icon-new-faqiliucheng"></i>
                <div className="right-box">
                  <div className="title">
                    {React.language("flow.create.n2")}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(BsyDashboardFlowPaneV2);
